/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientIssueValue
 */
export interface PatientIssueValue {
    /**
     * 
     * @type {string}
     * @memberof PatientIssueValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueValue
     */
    issue_type?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientIssueValue
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueValue
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueValue
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueValue
     */
    document_id?: string;
}

/**
 * Check if a given object implements the PatientIssueValue interface.
 */
export function instanceOfPatientIssueValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PatientIssueValueFromJSON(json: any): PatientIssueValue {
    return PatientIssueValueFromJSONTyped(json, false);
}

export function PatientIssueValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientIssueValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'issue_type': !exists(json, 'issue_type') ? undefined : json['issue_type'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
    };
}

export function PatientIssueValueToJSON(value?: PatientIssueValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'issue_type': value.issue_type,
        'date': value.date,
        'notes': value.notes,
        'status': value.status,
        'document_id': value.document_id,
    };
}

